import { PropsWithChildren } from 'react';
import { ButtonProps } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import cx from 'classnames';

import style from './button.module.scss';

interface CustomButtonProps extends ButtonProps {
  url?: string; // Optional URL to navigate
}

export const ButtonPrimary = ({
  children,
  url,
  onClick,
  ...props
}: PropsWithChildren<CustomButtonProps>) => {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (url) {
      navigate(url);
    } else if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      {...props}
      className={cx(style.btn1, props.className || style.defaultClassButton)} // Ensuring default class is used if no className is passed
      onClick={handleClick} // Delegate click handling
    >
      {children}
    </button>
  );
};
